import axios from 'axios';

import { axiosHeader, getV2OldRootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const getCustomerDashboard = () =>
  axios.get(
    `${getV2OldRootUrl()}/customer/${customerId()}/dashboard`,
    axiosHeader()
  );
